export const dnldFailoverReport = (builder) => ({
    dnldFailoverReport: builder.mutation({
        query: ({  search, status, fallbackChannel, loggedin_user_id, user_type_id, campaignType, startDate, endDate }) => {
            return {
                url: '/downloadFailoverReports',
                method: 'GET',
                params: {  search, status, fallbackChannel, loggedin_user_id, user_type_id, campaignType, startDate, endDate  },
                headers: {
                    'Content-Type':  'text/csv', 
                },
                responseHandler: (response) => response.blob(),
            };
        },
    }),
});